import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { logFirebaseConfig, checkFirebaseAuth } from "../utils/firebaseCheck";
import "../App.css"; // Updated CSS file
import logo from "../assets/logo.png"; // Ensure this is the correct path to your logo

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Check Firebase configuration on component mount
  useEffect(() => {
    logFirebaseConfig();
    checkFirebaseAuth().then(result => {
      if (!result.success) {
        console.warn("⚠️ Firebase Auth check:", result.message);
      } else {
        console.log("✅ Firebase Auth check:", result.message);
      }
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Sign in with Firebase Auth
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      
      // Store authentication token in localStorage
      const token = await userCredential.user.getIdToken();
      localStorage.setItem("token", token);
      
      // Login successful - navigate immediately
      navigate("/dashboard", { replace: true });
    } catch (error) {
      // Handle Firebase errors
      let errorMessage = "Login failed. Please try again.";
      
      switch (error.code) {
        case "auth/operation-not-allowed":
        case "auth/configuration-not-found":
          errorMessage = "Email/Password authentication is not enabled. Please enable it in Firebase Console. Check the browser console for more details.";
          console.error("❌ Firebase Auth Configuration Error:");
          console.error("1. Go to: https://console.firebase.google.com/");
          console.error(
            "2. Select project:",
            auth?.app?.options?.projectId || "(your Firebase project)"
          );
          console.error("3. Navigate to: Authentication > Sign-in method");
          console.error("4. Click on 'Email/Password'");
          console.error("5. Toggle 'Enable' to ON");
          console.error("6. Click 'Save'");
          logFirebaseConfig();
          break;
        case "auth/user-not-found":
          errorMessage = "No account found with this email. Please register first.";
          break;
        case "auth/wrong-password":
          errorMessage = "Incorrect password. Please try again.";
          break;
        case "auth/invalid-email":
          errorMessage = "Invalid email address.";
          break;
        case "auth/invalid-credential":
          errorMessage = "Invalid email or password.";
          break;
        case "auth/network-request-failed":
          errorMessage = "Network error. Please check your connection.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Too many failed attempts. Please try again later.";
          break;
        default:
          errorMessage = error.message || "Login failed. Please try again.";
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} alt="Timely Logo" className="logo-image" />
        <h1 className="tagline">Smart Appointments</h1>
        <p className="sub-tagline">Wait on your own terms.</p>

        {error && (
          <div className="error-message" style={{ 
            color: "#d32f2f", 
            backgroundColor: "#ffebee", 
            padding: "10px", 
            borderRadius: "5px", 
            marginBottom: "15px",
            fontSize: "14px"
          }}>
            {error}
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="input-label">Email</label>
          <input
            type="email"
            className="login-input"
            placeholder="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label className="input-label">Password</label>
          <input
            type="password"
            className="login-input"
            placeholder="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button 
            type="submit" 
            className="login-btn" 
            disabled={loading}
            style={{ opacity: loading ? 0.6 : 1, cursor: loading ? "not-allowed" : "pointer" }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <a href="/forgot-password" className="forgot-password">Forgot Password?</a>      </div>
    </div>
  );
}

export default LoginPage;
